'use client';

import { useOpenAuthModal } from '@/hooks/useOpenAuthModal';

export interface SignInHandlersResult {
  onLogin: () => void;
  isLoading: boolean;
}

export function useSignInHandlers(_onError?: (message: string | null) => void): SignInHandlersResult {
  const openAuthModal = useOpenAuthModal();

  return {
    onLogin: openAuthModal,
    isLoading: false,
  };
}
